/**
 * @generated SignedSource<<6f5482d73e9bcdc71ca1fca86b9ade62>>
 * @relayHash dbf51e27fa80444cf665ffe362776db0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f53f6c120642f4304dc4b144ec82ae36ad1b60a648375714465cda858c731bd

import type { ConcreteRequest, Query } from 'relay-runtime';
export type editHelpCenter_getHelpcenterById_Query$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type editHelpCenter_getHelpcenterById_Query$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly id?: string;
      readonly name?: {
        readonly default: string;
        readonly translations: ReadonlyArray<{
          readonly locale: string;
          readonly value: string;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly slug?: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type editHelpCenter_getHelpcenterById_Query = {
  response: editHelpCenter_getHelpcenterById_Query$data;
  variables: editHelpCenter_getHelpcenterById_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    {
      "concreteType": "HelpCenterName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "default"
        },
        {
          "concreteType": "HelpCenterTranslation",
          "kind": "LinkedField",
          "name": "translations",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "kind": "ScalarField",
              "name": "locale"
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "slug"
    }
  ],
  "type": "HelpCenter"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editHelpCenter_getHelpcenterById_Query",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "editHelpCenter_getHelpcenterById_Query",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3f53f6c120642f4304dc4b144ec82ae36ad1b60a648375714465cda858c731bd",
    "metadata": {},
    "name": "editHelpCenter_getHelpcenterById_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3dfbba1fa057669ce4e1d767d8437233";

export default node;
